$.widget("hotel.imodal", {
  _create: function () {
    var self = this;
    // create modal elements
    self.$modal = $("<div/>", { class: "modal" }); // add 'fade' to class for animation
    self.$dialog = $("<div/>", { class: "modal-dialog" });
    self.$content = $("<div/>", { class: "modal-content" });
    self.$spinner = $("<div/>", { class: "horizontal-spinner" });

    // fullscreen?
    if (self.element.data("fullscreen")) {
      self.$modal.addClass("fullscreen");
    }

    // nested?
    if (window.self !== window.top) {
      self.$modal.addClass("nested");
    }

    // append to DOM
    $(document.body)
      .append(self.$spinner)
      .append(self.$modal.append(self.$dialog.append(self.$content)));
  },

  _init: function () {
    var self = this;
    // show spinner, hide content
    self.$spinner.show();
    self.$content.hide();

    // create and append iframe
    self.$iframe = $("<iframe/>", {
      src: self.updateQueryString(
        "layout",
        $("#_layout") && $("#_layout").length
          ? $("#_layout").val() + "_modal"
          : "modal",
        self.element.attr("href")
      ),
      frameborder: 0,
      marginwidth: 0,
      marginheight: 0,
    });

    // attach event handlers
    self.$iframe.on("load", function () {
      self.iframeLoaded();
      if (!self.$modal.hasClass("fullscreen")) {
        setInterval(function () {
          self.iframeLoaded();
        }, 500);
      }
    });

    self.$content.html("").append(self.$iframe);

    // init bootstrap modal plugin
    self.$modal
      .modal({ show: true, backdrop: "static", keyboard: false })
      .off("hide.bs.modal")
      .on("hide.bs.modal", function (e) {
        return self.onHide(e);
      });
  },

  iframeLoaded: function () {
    try {
      var self = this;

      // show content, hide spinner
      self.$content.show();
      self.$spinner.hide();

      // if not fullscreen, size iframe
      if (!self.$modal.hasClass("fullscreen")) {
        self.$iframe[0].contentWindow.document.body.classList.add(
          "non-fullscreen-modal"
        );

        var height = self.$iframe[0].contentWindow.document.body.scrollHeight;
        self.$iframe.height(height); // 120px is the height of header + footer
      } else {
        if ($(self.$iframe[0]).parents("body.fullscreen").length) {
          $(self.$iframe[0].contentWindow.document.body).addClass(
            "nested-fullscreen"
          );
        } else {
          $(self.$iframe[0].contentWindow.document.body).addClass("fullscreen");
        }
      }

      parent.$(".popover.in").popover
        ? parent.$(".popover.in").popover("hide")
        : null;
      $(".popover.in").popover("hide");
    } catch (e) {
      // shhh...
    }
  },

  onHide: function (e) {
    var self = this;

    if (
      window.form_changed &&
      typeof window.ignore_unsaved_changes == "undefined"
    ) {
      bool = confirm(I18n.t("unsaved_changes"));
      if (bool == true) {
        self.$modal.remove();
      }
      return bool;
    } else {
      self.$modal.remove();
    }
  },

  updateQueryString: function (key, value, url) {
    if (!url) url = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
      hash;

    if (re.test(url)) {
      if (typeof value !== "undefined" && value !== null)
        return url.replace(re, "$1" + key + "=" + value + "$2$3");
      else {
        hash = url.split("#");
        url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
        if (typeof hash[1] !== "undefined" && hash[1] !== null)
          url += "#" + hash[1];
        return url;
      }
    } else {
      if (typeof value !== "undefined" && value !== null) {
        var separator = url.indexOf("?") !== -1 ? "&" : "?";
        hash = url.split("#");
        url = hash[0] + separator + key + "=" + value;
        if (typeof hash[1] !== "undefined" && hash[1] !== null)
          url += "#" + hash[1];
        return url;
      } else return url;
    }
  },
});
